import axios from "../../config/axiosConfig";
import { CREATE_MAIL_TEMPLATE, GET_MAIL_TEMPLATE, MAIL_TEMPLATE_REQUEST, DELETE_MAIL_TEMPLATE, UPDATE_MAIL_TEMPLATE, MAIL_TEMPLATE_REQUEST_FAILURE, GET_MAIL_TEMPLATE_MODULE, GET_MAIL_TEMPLATE_REQUEST_SUCCESS } from "../types";

export const getMailTemplateModules = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MAIL_TEMPLATE_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/mail-template/getMailTemplateModules", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_MAIL_TEMPLATE_MODULE, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getTemplateVariables = (module) => {
    return async (dispatch, getState) => {
        try {
        dispatch({ type: MAIL_TEMPLATE_REQUEST });
        const { auth } = getState();
        let params = { customerId: auth?.user?.Customer_Id, module: module };
        params = { ...params, companyId: auth.company?.id }
        return axios.get("/mail-template/getModuleVariebles", { params }).then((response) => {
            // if (response.data) {
            dispatch({ type: GET_MAIL_TEMPLATE_REQUEST_SUCCESS });
              return response?.data;
            // }
            return response;
        }).catch((error) => {
            console.error(error);
            dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
        });
        } catch (error) {
        console.error(error);
        dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
        throw error;
        }
    };
}

export const createMailTemplate = (mailTemplate) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: MAIL_TEMPLATE_REQUEST });
      return axios.post("/mail-template/add", mailTemplate,
        { params: { userId: auth.user?.id, customerId: auth?.user?.Customer_Id }}
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_MAIL_TEMPLATE, payload: response.data });
        } else {
          dispatch({
            type: MAIL_TEMPLATE_REQUEST_FAILURE,
            error: "Mail Template create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateMailTemplate = (id, mailTemplate) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: MAIL_TEMPLATE_REQUEST });
      return axios.post("/mail-template/update", { id, mailTemplate },
        { params: { userId: auth.user?.id }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_MAIL_TEMPLATE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: MAIL_TEMPLATE_REQUEST_FAILURE,
            error: "Mail Template update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteMailTemplate = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: MAIL_TEMPLATE_REQUEST });
      return axios.delete(`/mail-template/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_MAIL_TEMPLATE, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const sendTestMail = (mailTemplate) => {
  return async (dispatch, getState) => {
      try {
      dispatch({ type: MAIL_TEMPLATE_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };
      return axios.post("/mail-template/testing-mail-send", mailTemplate, { params }).then((response) => {
        dispatch({ type: GET_MAIL_TEMPLATE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
          console.error(error);
          dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      });
      } catch (error) {
      console.error(error);
      dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      throw error;
      }
  };
}

export const getBookMailTemplateModules = (type) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MAIL_TEMPLATE_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, type: type };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/mail-template/getMailTemplateModules", { params }).then((response) => {
        dispatch({ type: GET_MAIL_TEMPLATE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getBookMailTemplateMasterDetail = (bookId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MAIL_TEMPLATE_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id, bookId: bookId };
      return axios.get("/mail-template-master/get", { params }).then((response) => {
        dispatch({ type: GET_MAIL_TEMPLATE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getTemplateModuleWise = (bookId, moduleKey) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MAIL_TEMPLATE_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id, bookId, moduleKey };
      return axios.get("/mail-template-master/get-module-wise", { params }).then((response) => {
        dispatch({ type: GET_MAIL_TEMPLATE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MAIL_TEMPLATE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

